import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import TagManager from 'react-gtm-module';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router/dom';
import { PersistGate } from 'redux-persist/integration/react';

import { settings } from '@/_config';
import { useIsMounted } from '@/_shared';
import getTheme from '@/_shared/themes';
import { store, persistor } from '@/_state';

import router from './root-router';

/**
 * Entry point for app logic
 * All global initializations and declarations are done here
  
 * <Provider store: Connect redux to app
 * <PersistGate:  Initialize State persistor
 * <ThemeProvider: Provide theme context to all code
 * <CssBaseline: Initialize all base css for old browsers
 * <ErrorBoundary: Capture unwanted bugs
 * <Administrator: Initializing snack bars loaders, login etc.
 * <RouteController: Main router for the app
 */

if (settings.isATP && settings.isStaging) {
  TagManager.initialize({
    gtmId: 'GTM-KNJSPJFN',
  });
}

function EntryPoint() {
  const theme = getTheme();

  useIsMounted(() => {
    const elm = document.getElementById('preloader');
    if (typeof elm !== 'undefined' && elm !== null) {
      elm.style.display = 'none';
    }
  });

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <RouterProvider router={router} />
          </ThemeProvider>
        </StyledEngineProvider>
      </PersistGate>
    </Provider>
  );
}

export default EntryPoint;
